<template>
    <div class="modal" :id="compModalIdentifier" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered" style="max-width: 900px;">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title text-center">
                        {{ isEdit ? 'Edit' : 'Create' }} Driver Note
                    </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body bg-light" style="">
                    <p class="mb-2">{{ driverNote }}</p>
                    <textarea class="w-100" v-model="newDriverNote" name="driver_note" id="driver_note" cols="30" rows="10"></textarea>
                </div>
                <div class="modal-footer">
                    <button type="button"
                            :id="'create_' + getModalType() + 'contact_close_button'"
                            class="btn btn-secondary"
                            data-bs-dismiss="modal">Close</button>

                    <button type="button" class="btn btn-primary" @click="createNewExpense" >
                        {{ isEdit ? 'Update' : 'Save' }}
                    </button>
                </div>

            </div>
        </div>
    </div>
</template>

<script setup>

import { ref, computed, onMounted } from 'vue';
import axios from 'axios';
import Modal from 'bootstrap/js/dist/modal';
import Swal from "sweetalert2";

const props = defineProps({
    identifier: {
        type: String,
        default: '',
        required: false,
    },
    movement: {
        type: Object,
        default: () => {},
        required: false,
    },
    modelValue: {
        type: String,
        default: '',
    },
    driverNote: {
        type: String,
        default: '',
    },
    isEdit: {
        type: Boolean,
        default: false,
        required: false,
    },
    modalFor: {
        type: String,
        default: '',
        required: false,
    }
})

const emit = defineEmits(['update:modelValue']);

const modal = ref('');
const label = ref('');
const newDriverNote = ref('');

const getModalType = () => {
    return props.modalFor !== '' ? props.modalFor + '_' : '';
}

const createNewExpense = () => {

    const data = {
        movement_id: props.movement.id,
        driver_note: newDriverNote.value
    };

    const url = props.isEdit
        ? route('api.movements.movements.driver-note.update', { movement: props.movement.id })
        : route('api.movements.movements.store');

    const method = props.isEdit ? 'patch' : 'post';

    axios[method]( url, data, {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        }
    })
        .then(() => {

            emit('update:modelValue', newDriverNote.value);

            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: "Success!",
                text: props.isEdit ? 'Movement Updated!' : 'Movement Created!',
                timer: 3000,
                timerProgressBar: true,
                showConfirmButton: false,
            });

            window.jQuery('.modal-header .btn-close').click();

        })
        .catch( error => {

            const errorMessages = error.response.data.errors;

            let allErrors = '';

            Object.entries(errorMessages).forEach(([, messages]) => {
                messages.forEach(errorMessage => {
                    allErrors += '<p class="mb-0">' + errorMessage + '</p>';
                });
            });

            Swal.fire({
                toast: true,
                position: 'top-end',
                title: 'Error Updating Job',
                html: allErrors,
                icon: 'error',
                confirmButtonText: 'OK',
                confirmButtonColor: '#dc3545',
                width: '600px',
            });

        });
}

const compModalIdentifier = computed(() => {
    return props.identifier + '_driver_note_modal'
})

onMounted(() => {
    modal.value = new Modal(document.getElementById(compModalIdentifier.value))
    newDriverNote.value = props.modelValue;

    // Listen for modal close to remove 'edit_driver_text' param
    const modalEl = document.getElementById(compModalIdentifier.value);
    if (modalEl) {
        modalEl.addEventListener('hidden.bs.modal', () => {
            const url = new URL(window.location.href);
            if (url.searchParams.get('edit_driver_text') === '1') {
                url.searchParams.delete('edit_driver_text');
                window.history.replaceState({}, '', url.pathname + url.search);
            }
        });
    }
})

</script>
